import Home from "./page/";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NovartisHealthImprovement from "./page/NovartisHealthImprovement";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/novartis-health-improvement"
          element={<NovartisHealthImprovement />}
        />
      </Routes>
    </Router>
  );
}

export default App;
